import React, {useContext} from 'react';
import {useParams} from "react-router-dom";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import IconCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import OrganizationListPageTemplate from "../../../../components/Templates/OrganizationListPageTemplate";
import {AuthContext} from "../../../../context/AuthContext";
import {AddOrganizationByRoleId} from "../../../../components/Modals/addOrganizationByRoleId";

function Organizations_medcenter() {
    const {REACT_APP_URL_PREFIX} = process.env
    const {medId, medName, verCenterId} = useParams()
    const {token} = useContext(AuthContext)

    const url = `/api/v2/systemManagers/${token.userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations?`

    const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Мед. центры', link: process.env.REACT_APP_URL_PREFIX + '/counterAgents/medCenters'},
        {title: medName, actual: true},
    ]

    const linkCellToHistory = props => {
        const url = REACT_APP_URL_PREFIX + `/counterAgents/medCenters/${medId}/${medName}/${verCenterId}/organizations/${props.idArr[0]}/${props.cellContent}/history`
        return <LinkCell3 linkRoute={url} linkTitle={props.cellContent}
                          editClick={e => props.cellData.onClick(props.idArr[0])}/>
    }
    const linkCellToCalndar = props => {
        const orgId = props.idArr[0]
        const orgName = props.cellContent
        return <IconCell iconName={'calendar'}
                         to={REACT_APP_URL_PREFIX + `/calendar/medCenter/${medId}/${medName}/organization/${orgId}/${orgName}`}/>
    }


    tableModel.haveToShow[0].typeData.cell = linkCellToHistory
    tableModel.haveToShow[1].typeData.cell = linkCellToCalndar

    return (
        <OrganizationListPageTemplate tableModel={tableModel}
                                      breadCrumbsItems={breadCrumbsItems} roleIs={3}
                                      getOrgListAPI={url}
                                      addOrgAPI={AddOrganizationByRoleId(3, token.userId, verCenterId, medId).api}/>
    );
}

export default Organizations_medcenter;

var tableModel = {
    firstRow: [
        {title: 'Название', id: 'name'},
        {title: 'Каленадрь', id: ''},
        {title: 'Количество пациентов', id: ''}, // Сортировка не добавлена
        {title: 'Вызов', id: ''},                // Сортировка не добавлена
    ],
    haveToShow: [
        {id: 'name', idArr: ['id'], type: 'wrapperCell', typeData: {cell: () => {}}},
        {id: 'name', idArr: ['id'], type: 'wrapperCell', typeData: {cell: () => {}}},
        {id: 'patients_count'},
        {id: 'invite_count'}
    ]
}

